import { Injectable } from '@angular/core';

/**
 *  Service to manage environment configurations for the application.
 *  Provides methods to check if the application is running in a local development environment
 *  and to retrieve the domain name from the current URL.
 *
 *  This file structure is copied from libs/chargeye/app-core/ce-environment/src/lib/service/env.service.ts
 *
 */
@Injectable({ providedIn: 'root' })
export class EnvService {
    /**
     * Determines if the current hostname is a local development environment.
     *
     * If the `override` parameter is provided, its value is returned directly,
     * allowing manual control over the result (useful for testing or bypassing logic).
     *
     * @param {boolean} [override] - Optional override flag. If specified, this value is returned as-is.
     * @returns {boolean} `true` if running on localhost or overridden; otherwise, `false`.
     */
    isLocalHost(override?: boolean): boolean {
        if (override !== undefined) {
            return override;
        }
        const hostname = window?.location?.hostname;
        const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
        return isLocal;
    }

}
